// extracted by mini-css-extract-plugin
module.exports =  {"button":"d30e7684c4--button--gs5R_","loading":"d30e7684c4--loading--fC43r","spinner":"d30e7684c4--spinner--rWSqM"};